import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { announce as $3yVy0$announce } from "@react-aria/live-announcer";
import { ariaHideOutside as $3yVy0$ariaHideOutside } from "@react-aria/overlays";
import { listData as $3yVy0$listData, getItemId as $3yVy0$getItemId } from "@react-aria/listbox";
import { chain as $3yVy0$chain, useLabels as $3yVy0$useLabels, isAppleDevice as $3yVy0$isAppleDevice, mergeProps as $3yVy0$mergeProps } from "@react-aria/utils";
import { useMemo as $3yVy0$useMemo, useRef as $3yVy0$useRef, useEffect as $3yVy0$useEffect } from "react";
import { getChildNodes as $3yVy0$getChildNodes, getItemCount as $3yVy0$getItemCount } from "@react-stately/collections";
import { ListKeyboardDelegate as $3yVy0$ListKeyboardDelegate, useSelectableCollection as $3yVy0$useSelectableCollection } from "@react-aria/selection";
import { useLocalizedStringFormatter as $3yVy0$useLocalizedStringFormatter } from "@react-aria/i18n";
import { useMenuTrigger as $3yVy0$useMenuTrigger } from "@react-aria/menu";
import { useTextField as $3yVy0$useTextField } from "@react-aria/textfield";
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

var $2e84e748dc57e459$exports = {};
var $02cb4c75c506befe$exports = {};
$02cb4c75c506befe$exports = {
  "buttonLabel": "\u0639\u0631\u0636 \u0627\u0644\u0645\u0642\u062A\u0631\u062D\u0627\u062A",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u062E\u064A\u0627\u0631");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u062E\u064A\u0627\u0631\u0627\u062A");
      }
    }), " \u0645\u062A\u0627\u062D\u0629.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u0627\u0644\u0645\u062C\u0645\u0648\u0639\u0629 \u0627\u0644\u0645\u062F\u062E\u0644\u0629 ".concat(args.groupTitle, ", \u0645\u0639 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u062E\u064A\u0627\u0631");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u062E\u064A\u0627\u0631\u0627\u062A");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u0645\u062D\u062F\u062F",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u0645\u0642\u062A\u0631\u062D\u0627\u062A",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, "\u060C \u0645\u062D\u062F\u062F");
  }
};
var $568b8163f1e56faf$exports = {};
$568b8163f1e56faf$exports = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0436\u0438 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u043E\u043F\u0446\u0438\u044F");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u043E\u043F\u0446\u0438\u0438");
      }
    }), " \u043D\u0430 \u0440\u0430\u0437\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u0412\u044A\u0432\u0435\u0434\u0435\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 ".concat(args.groupTitle, ", \u0441 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u043E\u043F\u0446\u0438\u044F");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u043E\u043F\u0446\u0438\u0438");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u0438\u0437\u0431\u0440\u0430\u043D\u0438",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u0438\u0437\u0431\u0440\u0430\u043D\u0438");
  }
};
var $87581c0202d106b8$exports = {};
$87581c0202d106b8$exports = {
  "buttonLabel": "Zobrazit doporu\u010Den\xED",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "K dispozici ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "je ".concat(formatter.number(args.optionCount), " mo\u017Enost");
      },
      other: function other() {
        return "jsou/je ".concat(formatter.number(args.optionCount), " mo\u017Enosti/-\xED");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Zadan\xE1 skupina \u201E".concat(args.groupTitle, "\u201C ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "s ".concat(formatter.number(args.groupCount), " mo\u017Enost\xED");
          },
          other: function other() {
            return "se ".concat(formatter.number(args.groupCount), " mo\u017Enostmi");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: " (vybr\xE1no)",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "N\xE1vrhy",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", vybr\xE1no");
  }
};
var $a10a0369f5433ed1$exports = {};
$a10a0369f5433ed1$exports = {
  "buttonLabel": "Vis forslag",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " mulighed tilg\xE6ngelig");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " muligheder tilg\xE6ngelige");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Angivet gruppe ".concat(args.groupTitle, ", med ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " mulighed");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " muligheder");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valgt",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Forslag",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valgt");
  }
};
var $bfd288727d5cb166$exports = {};
$bfd288727d5cb166$exports = {
  "buttonLabel": "Empfehlungen anzeigen",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " Option");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " Optionen");
      }
    }), " verf\xFCgbar.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Eingetretene Gruppe ".concat(args.groupTitle, ", mit ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " Option");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " Optionen");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", ausgew\xE4hlt",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Empfehlungen",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", ausgew\xE4hlt");
  }
};
var $ca177778f9a74e3c$exports = {};
$ca177778f9a74e3c$exports = {
  "buttonLabel": "\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03C0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03C9\u03BD",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 ");
      }
    }), " \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u0395\u03B9\u03C3\u03B1\u03B3\u03BC\u03AD\u03BD\u03B7 \u03BF\u03BC\u03AC\u03B4\u03B1 ".concat(args.groupTitle, ", \u03BC\u03B5 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03BF",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u03A0\u03C1\u03BF\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u03B5\u03C0\u03B9\u03BB\u03AD\u03C7\u03B8\u03B7\u03BA\u03B5");
  }
};
var $9b5aa79ef84beb6c$exports = {};
$9b5aa79ef84beb6c$exports = {
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Entered group ".concat(args.groupTitle, ", with ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " option");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " options");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selected",
      other: ""
    }, args.isSelected));
  },
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " option");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " options");
      }
    }), " available.");
  },
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selected");
  },
  "buttonLabel": "Show suggestions",
  "listboxLabel": "Suggestions"
};
var $57968e8209de2557$exports = {};
$57968e8209de2557$exports = {
  "buttonLabel": "Mostrar sugerencias",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opci\xF3n");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opciones");
      }
    }), " disponible(s).");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Se ha unido al grupo ".concat(args.groupTitle, ", con ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opci\xF3n");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opciones");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", seleccionado",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugerencias",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", seleccionado");
  }
};
var $60690790bf4c1c6a$exports = {};
$60690790bf4c1c6a$exports = {
  "buttonLabel": "Kuva soovitused",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " valik");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " valikud");
      }
    }), " saadaval.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Sisestatud r\xFChm ".concat(args.groupTitle, ", valikuga ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " valik");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " valikud");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valitud",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Soovitused",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valitud");
  }
};
var $1101246e8c7d9357$exports = {};
$1101246e8c7d9357$exports = {
  "buttonLabel": "N\xE4yt\xE4 ehdotukset",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " vaihtoehto");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " vaihtoehdot");
      }
    }), " saatavilla.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Mentiin ryhm\xE4\xE4n ".concat(args.groupTitle, ", ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " vaihtoehdon");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " vaihtoehdon");
          }
        }), " kanssa.");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valittu",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Ehdotukset",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valittu");
  }
};
var $6404b5cb5b241730$exports = {};
$6404b5cb5b241730$exports = {
  "buttonLabel": "Afficher les suggestions",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " option");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " options");
      }
    }), " disponible(s).");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Groupe ".concat(args.groupTitle, " saisi, avec ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " option");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " options");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", s\xE9lectionn\xE9(s)",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Suggestions",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", s\xE9lectionn\xE9");
  }
};
var $dfeafa702e92e31f$exports = {};
$dfeafa702e92e31f$exports = {
  "buttonLabel": "\u05D4\u05E6\u05D2 \u05D4\u05E6\u05E2\u05D5\u05EA",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA ".concat(formatter.number(args.optionCount));
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA");
      }
    }), " \u05D1\u05DE\u05E6\u05D1 \u05D6\u05DE\u05D9\u05DF.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u05E0\u05DB\u05E0\u05E1 \u05DC\u05E7\u05D1\u05D5\u05E6\u05D4 ".concat(args.groupTitle, ", \u05E2\u05DD ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "\u05D0\u05E4\u05E9\u05E8\u05D5\u05EA ".concat(formatter.number(args.groupCount));
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u05E0\u05D1\u05D7\u05E8",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u05D4\u05E6\u05E2\u05D5\u05EA",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u05E0\u05D1\u05D7\u05E8");
  }
};
var $2d125e0b34676352$exports = {};
$2d125e0b34676352$exports = {
  "buttonLabel": "Prika\u017Ei prijedloge",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Dostupno jo\u0161: ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcija");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcije/a");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Unesena skupina ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opcijom");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opcije/a");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", odabranih",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Prijedlozi",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", odabrano");
  }
};
var $ea029611d7634059$exports = {};
$ea029611d7634059$exports = {
  "buttonLabel": "Javaslatok megjelen\xEDt\xE9se",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " lehet\u0151s\xE9g");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " lehet\u0151s\xE9g");
      }
    }), " \xE1ll rendelkez\xE9sre.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Bel\xE9pett a(z) ".concat(args.groupTitle, " csoportba, amely ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " lehet\u0151s\xE9get");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " lehet\u0151s\xE9get");
          }
        }), " tartalmaz. ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", kijel\xF6lve",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Javaslatok",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", kijel\xF6lve");
  }
};
var $77f075bb86ad7091$exports = {};
$77f075bb86ad7091$exports = {
  "buttonLabel": "Mostra suggerimenti",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opzione disponibile");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opzioni disponibili");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Ingresso nel gruppo ".concat(args.groupTitle, ", con ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opzione");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opzioni");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selezionato",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Suggerimenti",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selezionato");
  }
};
var $6e87462e84907983$exports = {};
$6e87462e84907983$exports = {
  "buttonLabel": "\u5019\u88DC\u3092\u8868\u793A",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
      }
    }), "\u3092\u5229\u7528\u3067\u304D\u307E\u3059\u3002");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u5165\u529B\u3055\u308C\u305F\u30B0\u30EB\u30FC\u30D7 ".concat(args.groupTitle, "\u3001").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u500B\u306E\u30AA\u30D7\u30B7\u30E7\u30F3");
          }
        }), "\u3092\u542B\u3080\u3002");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: "\u3001\u9078\u629E\u6E08\u307F",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u5019\u88DC",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, "\u3001\u9078\u629E\u6E08\u307F");
  }
};
var $9246f2c6edc6b232$exports = {};
$9246f2c6edc6b232$exports = {
  "buttonLabel": "\uC81C\uC548 \uC0AC\uD56D \uD45C\uC2DC",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), "\uAC1C \uC635\uC158");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), "\uAC1C \uC635\uC158");
      }
    }), "\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\uC785\uB825\uD55C \uADF8\uB8F9 ".concat(args.groupTitle, ", ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), "\uAC1C \uC635\uC158");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), "\uAC1C \uC635\uC158");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \uC120\uD0DD\uB428",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\uC81C\uC548",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \uC120\uD0DD\uB428");
  }
};
var $e587accc6c0a434c$exports = {};
$e587accc6c0a434c$exports = {
  "buttonLabel": "Rodyti pasi\u016Blymus",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Yra ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " parinktis");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " parinktys (-i\u0173)");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u012Evesta grup\u0117 ".concat(args.groupTitle, ", su ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " parinktimi");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " parinktimis (-i\u0173)");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", pasirinkta",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Pasi\u016Blymai",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", pasirinkta");
  }
};
var $03a1900e7400b5ab$exports = {};
$03a1900e7400b5ab$exports = {
  "buttonLabel": "R\u0101d\u012Bt ieteikumus",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Pieejamo opciju skaits: ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcija");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcijas");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Ievad\u012Bta grupa ".concat(args.groupTitle, ", ar ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opciju");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opcij\u0101m");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", atlas\u012Bta",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Ieteikumi",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", atlas\u012Bta");
  }
};
var $1387676441be6cf6$exports = {};
$1387676441be6cf6$exports = {
  "buttonLabel": "Vis forslag",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " alternativ");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " alternativer");
      }
    }), " finnes.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Angitt gruppe ".concat(args.groupTitle, ", med ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " alternativ");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " alternativer");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valgt",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Forslag",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valgt");
  }
};
var $17e82ebf0f8ab91f$exports = {};
$17e82ebf0f8ab91f$exports = {
  "buttonLabel": "Suggesties weergeven",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " optie");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opties");
      }
    }), " beschikbaar.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Groep ".concat(args.groupTitle, " ingevoerd met ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " optie");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opties");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", geselecteerd",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Suggesties",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", geselecteerd");
  }
};
var $2f5377d3471630e5$exports = {};
$2f5377d3471630e5$exports = {
  "buttonLabel": "Wy\u015Bwietlaj sugestie",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "dost\u0119pna/dost\u0119pne(-nych) ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcja");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcje(-i)");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Do\u0142\u0105czono do grupy ".concat(args.groupTitle, ", z ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opcj\u0105");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opcjami");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", wybrano",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugestie",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", wybrano");
  }
};
var $dee9868b6fa95ffe$exports = {};
$dee9868b6fa95ffe$exports = {
  "buttonLabel": "Mostrar sugest\xF5es",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xE3o");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xF5es");
      }
    }), " dispon\xEDvel.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Grupo inserido ".concat(args.groupTitle, ", com ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xE3o");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xF5es");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selecionado",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugest\xF5es",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selecionado");
  }
};
var $f8b2e63637cbb5a6$exports = {};
$f8b2e63637cbb5a6$exports = {
  "buttonLabel": "Apresentar sugest\xF5es",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xE3o");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xF5es");
      }
    }), " dispon\xEDvel.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Grupo introduzido ".concat(args.groupTitle, ", com ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xE3o");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xF5es");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selecionado",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugest\xF5es",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selecionado");
  }
};
var $46a885db3b44ea95$exports = {};
$46a885db3b44ea95$exports = {
  "buttonLabel": "Afi\u0219are sugestii",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " op\u021Biune");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " op\u021Biuni");
      }
    }), " disponibile.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Grup ".concat(args.groupTitle, " introdus, cu ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " op\u021Biune");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " op\u021Biuni");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", selectat",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugestii",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selectat");
  }
};
var $50d8a8f0afa9dee5$exports = {};
$50d8a8f0afa9dee5$exports = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u0432");
      }
    }), " \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u0412\u0432\u0435\u0434\u0435\u043D\u043D\u0430\u044F \u0433\u0440\u0443\u043F\u043F\u0430 ".concat(args.groupTitle, ", \u0441 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u043E\u043C");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0430\u043C\u0438");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u043C\u0438",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u0432\u044B\u0431\u0440\u0430\u043D\u043E");
  }
};
var $2867ee6173245507$exports = {};
$2867ee6173245507$exports = {
  "buttonLabel": "Zobrazi\u0165 n\xE1vrhy",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " mo\u017Enos\u0165");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " mo\u017Enosti/-\xED");
      }
    }), " k dispoz\xEDcii.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Zadan\xE1 skupina ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " mo\u017Enos\u0165ou");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " mo\u017Enos\u0165ami");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", vybrat\xE9",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "N\xE1vrhy",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", vybrat\xE9");
  }
};
var $0631b65beeb09b50$exports = {};
$0631b65beeb09b50$exports = {
  "buttonLabel": "Prika\u017Ei predloge",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Na voljo je ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcija");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcije");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Vnesena skupina ".concat(args.groupTitle, ", z ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opcija");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " opcije");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", izbrano",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Predlogi",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", izbrano");
  }
};
var $65fc749265dcd686$exports = {};
$65fc749265dcd686$exports = {
  "buttonLabel": "Prika\u017Ei predloge",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "Dostupno jo\u0161: ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " opcija");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " opcije/a");
      }
    }), ".");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Unesena grupa ".concat(args.groupTitle, ", s ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " opcijom");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " optione/a");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", izabranih",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Predlozi",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", izabrano");
  }
};
var $69ba655c7853c08e$exports = {};
$69ba655c7853c08e$exports = {
  "buttonLabel": "Visa f\xF6rslag",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " alternativ");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " alternativ");
      }
    }), " tillg\xE4ngliga.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Ingick i gruppen ".concat(args.groupTitle, " med ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " alternativ");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " alternativ");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", valda",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "F\xF6rslag",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", valda");
  }
};
var $a79794784d61577c$exports = {};
$a79794784d61577c$exports = {
  "buttonLabel": "\xD6nerileri g\xF6ster",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " se\xE7enek");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " se\xE7enekler");
      }
    }), " kullan\u0131labilir.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "Girilen grup ".concat(args.groupTitle, ", ile ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " se\xE7enek");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " se\xE7enekler");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", se\xE7ildi",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\xD6neriler",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", se\xE7ildi");
  }
};
var $c2845791417ebaf4$exports = {};
$c2845791417ebaf4$exports = {
  "buttonLabel": "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u043F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438(-\u0456\u0432)");
      }
    }), " \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u0412\u0432\u0435\u0434\u0435\u043D\u0430 \u0433\u0440\u0443\u043F\u0430 ".concat(args.groupTitle, ", \u0437 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438(-\u0456\u0432)");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u0432\u0438\u0431\u0440\u0430\u043D\u043E",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u041F\u0440\u043E\u043F\u043E\u0437\u0438\u0446\u0456\u0457",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u0432\u0438\u0431\u0440\u0430\u043D\u043E");
  }
};
var $29b642d0025cc7a4$exports = {};
$29b642d0025cc7a4$exports = {
  "buttonLabel": "\u663E\u793A\u5EFA\u8BAE",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "\u6709 ".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u4E2A\u9009\u9879");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u4E2A\u9009\u9879");
      }
    }), "\u53EF\u7528\u3002");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u8FDB\u5165\u4E86 ".concat(args.groupTitle, " \u7EC4\uFF0C\u5176\u4E2D\u6709 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u4E2A\u9009\u9879");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u4E2A\u9009\u9879");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u5DF2\u9009\u62E9",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u5EFA\u8BAE",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u5DF2\u9009\u62E9");
  }
};
var $cd36dd33f9d46936$exports = {};
$cd36dd33f9d46936$exports = {
  "buttonLabel": "\u986F\u793A\u5EFA\u8B70",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " \u9078\u9805");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " \u9078\u9805");
      }
    }), " \u53EF\u7528\u3002");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      true: function _true() {
        return "\u8F38\u5165\u7684\u7FA4\u7D44 ".concat(args.groupTitle, ", \u6709 ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " \u9078\u9805");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " \u9078\u9805");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      true: ", \u5DF2\u9078\u53D6",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "\u5EFA\u8B70",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", \u5DF2\u9078\u53D6");
  }
};
$2e84e748dc57e459$exports = {
  "ar-AE": $02cb4c75c506befe$exports,
  "bg-BG": $568b8163f1e56faf$exports,
  "cs-CZ": $87581c0202d106b8$exports,
  "da-DK": $a10a0369f5433ed1$exports,
  "de-DE": $bfd288727d5cb166$exports,
  "el-GR": $ca177778f9a74e3c$exports,
  "en-US": $9b5aa79ef84beb6c$exports,
  "es-ES": $57968e8209de2557$exports,
  "et-EE": $60690790bf4c1c6a$exports,
  "fi-FI": $1101246e8c7d9357$exports,
  "fr-FR": $6404b5cb5b241730$exports,
  "he-IL": $dfeafa702e92e31f$exports,
  "hr-HR": $2d125e0b34676352$exports,
  "hu-HU": $ea029611d7634059$exports,
  "it-IT": $77f075bb86ad7091$exports,
  "ja-JP": $6e87462e84907983$exports,
  "ko-KR": $9246f2c6edc6b232$exports,
  "lt-LT": $e587accc6c0a434c$exports,
  "lv-LV": $03a1900e7400b5ab$exports,
  "nb-NO": $1387676441be6cf6$exports,
  "nl-NL": $17e82ebf0f8ab91f$exports,
  "pl-PL": $2f5377d3471630e5$exports,
  "pt-BR": $dee9868b6fa95ffe$exports,
  "pt-PT": $f8b2e63637cbb5a6$exports,
  "ro-RO": $46a885db3b44ea95$exports,
  "ru-RU": $50d8a8f0afa9dee5$exports,
  "sk-SK": $2867ee6173245507$exports,
  "sl-SI": $0631b65beeb09b50$exports,
  "sr-SP": $65fc749265dcd686$exports,
  "sv-SE": $69ba655c7853c08e$exports,
  "tr-TR": $a79794784d61577c$exports,
  "uk-UA": $c2845791417ebaf4$exports,
  "zh-CN": $29b642d0025cc7a4$exports,
  "zh-TW": $cd36dd33f9d46936$exports
};
function $c350ade66beef0af$export$8c18d1b4f7232bbf(props, state) {
  var buttonRef = props.buttonRef,
    popoverRef = props.popoverRef,
    inputRef = props.inputRef,
    listBoxRef = props.listBoxRef,
    keyboardDelegate = props.keyboardDelegate,
    // completionMode = 'suggest',
    shouldFocusWrap = props.shouldFocusWrap,
    isReadOnly = props.isReadOnly,
    isDisabled = props.isDisabled;
  var stringFormatter = (0, $3yVy0$useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($2e84e748dc57e459$exports)));
  var _ref = (0, $3yVy0$useMenuTrigger)({
      type: "listbox",
      isDisabled: isDisabled || isReadOnly
    }, state, buttonRef),
    menuTriggerProps = _ref.menuTriggerProps,
    menuProps = _ref.menuProps;
  // Set listbox id so it can be used when calling getItemId later
  (0, $3yVy0$listData).set(state, {
    id: menuProps.id
  });
  // By default, a KeyboardDelegate is provided which uses the DOM to query layout information (e.g. for page up/page down).
  // When virtualized, the layout object will be passed in as a prop and override this.
  var delegate = (0, $3yVy0$useMemo)(function () {
    return keyboardDelegate || new (0, $3yVy0$ListKeyboardDelegate)(state.collection, state.disabledKeys, listBoxRef);
  }, [keyboardDelegate, state.collection, state.disabledKeys, listBoxRef]);
  // Use useSelectableCollection to get the keyboard handlers to apply to the textfield
  var _ref2 = (0, $3yVy0$useSelectableCollection)({
      selectionManager: state.selectionManager,
      keyboardDelegate: delegate,
      disallowTypeAhead: true,
      disallowEmptySelection: true,
      shouldFocusWrap: shouldFocusWrap,
      ref: inputRef,
      // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
      isVirtualized: true
    }),
    collectionProps = _ref2.collectionProps;
  // For textfield specific keydown operations
  var onKeyDown = function onKeyDown(e) {
    switch (e.key) {
      case "Enter":
      case "Tab":
        // Prevent form submission if menu is open since we may be selecting a option
        if (state.isOpen && e.key === "Enter") e.preventDefault();
        state.commit();
        break;
      case "Escape":
        if (state.selectedKey !== null || state.inputValue === "" || props.allowsCustomValue) e.continuePropagation();
        state.revert();
        break;
      case "ArrowDown":
        state.open("first", "manual");
        break;
      case "ArrowUp":
        state.open("last", "manual");
        break;
      case "ArrowLeft":
      case "ArrowRight":
        state.selectionManager.setFocusedKey(null);
        break;
    }
  };
  var onBlur = function onBlur(e) {
    var _popoverRef_current;
    // Ignore blur if focused moved to the button or into the popover.
    if (e.relatedTarget === (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) || ((_popoverRef_current = popoverRef.current) === null || _popoverRef_current === void 0 ? void 0 : _popoverRef_current.contains(e.relatedTarget))) return;
    if (props.onBlur) props.onBlur(e);
    state.setFocused(false);
  };
  var onFocus = function onFocus(e) {
    if (state.isFocused) return;
    if (props.onFocus) props.onFocus(e);
    state.setFocused(true);
  };
  var _ref3 = (0, $3yVy0$useTextField)(_objectSpread(_objectSpread({}, props), {}, {
      onChange: state.setInputValue,
      onKeyDown: !isReadOnly && (0, $3yVy0$chain)(state.isOpen && collectionProps.onKeyDown, onKeyDown, props.onKeyDown),
      onBlur: onBlur,
      value: state.inputValue,
      onFocus: onFocus,
      autoComplete: "off"
    }), inputRef),
    labelProps = _ref3.labelProps,
    inputProps = _ref3.inputProps,
    descriptionProps = _ref3.descriptionProps,
    errorMessageProps = _ref3.errorMessageProps;
  // Press handlers for the ComboBox button
  var onPress = function onPress(e) {
    if (e.pointerType === "touch") {
      // Focus the input field in case it isn't focused yet
      inputRef.current.focus();
      state.toggle(null, "manual");
    }
  };
  var onPressStart = function onPressStart(e) {
    if (e.pointerType !== "touch") {
      inputRef.current.focus();
      state.toggle(e.pointerType === "keyboard" || e.pointerType === "virtual" ? "first" : null, "manual");
    }
  };
  var triggerLabelProps = (0, $3yVy0$useLabels)({
    id: menuTriggerProps.id,
    "aria-label": stringFormatter.format("buttonLabel"),
    "aria-labelledby": props["aria-labelledby"] || labelProps.id
  });
  var listBoxProps = (0, $3yVy0$useLabels)({
    id: menuProps.id,
    "aria-label": stringFormatter.format("listboxLabel"),
    "aria-labelledby": props["aria-labelledby"] || labelProps.id
  });
  // If a touch happens on direct center of ComboBox input, might be virtual click from iPad so open ComboBox menu
  var lastEventTime = (0, $3yVy0$useRef)(0);
  var onTouchEnd = function onTouchEnd(e) {
    if (isDisabled || isReadOnly) return;
    // Sometimes VoiceOver on iOS fires two touchend events in quick succession. Ignore the second one.
    if (e.timeStamp - lastEventTime.current < 500) {
      e.preventDefault();
      inputRef.current.focus();
      return;
    }
    var rect = e.target.getBoundingClientRect();
    var touch = e.changedTouches[0];
    var centerX = Math.ceil(rect.left + .5 * rect.width);
    var centerY = Math.ceil(rect.top + .5 * rect.height);
    if (touch.clientX === centerX && touch.clientY === centerY) {
      e.preventDefault();
      inputRef.current.focus();
      state.toggle(null, "manual");
      lastEventTime.current = e.timeStamp;
    }
  };
  // VoiceOver has issues with announcing aria-activedescendant properly on change
  // (especially on iOS). We use a live region announcer to announce focus changes
  // manually. In addition, section titles are announced when navigating into a new section.
  var focusedItem = state.selectionManager.focusedKey != null && state.isOpen ? state.collection.getItem(state.selectionManager.focusedKey) : undefined;
  var _focusedItem_parentKey;
  var sectionKey = (_focusedItem_parentKey = focusedItem === null || focusedItem === void 0 ? void 0 : focusedItem.parentKey) !== null && _focusedItem_parentKey !== void 0 ? _focusedItem_parentKey : null;
  var _state_selectionManager_focusedKey;
  var itemKey = (_state_selectionManager_focusedKey = state.selectionManager.focusedKey) !== null && _state_selectionManager_focusedKey !== void 0 ? _state_selectionManager_focusedKey : null;
  var lastSection = (0, $3yVy0$useRef)(sectionKey);
  var lastItem = (0, $3yVy0$useRef)(itemKey);
  (0, $3yVy0$useEffect)(function () {
    if ((0, $3yVy0$isAppleDevice)() && focusedItem != null && itemKey !== lastItem.current) {
      var isSelected = state.selectionManager.isSelected(itemKey);
      var section = sectionKey != null ? state.collection.getItem(sectionKey) : null;
      var sectionTitle = (section === null || section === void 0 ? void 0 : section["aria-label"]) || (typeof (section === null || section === void 0 ? void 0 : section.rendered) === "string" ? section.rendered : "") || "";
      var announcement = stringFormatter.format("focusAnnouncement", {
        isGroupChange: section && sectionKey !== lastSection.current,
        groupTitle: sectionTitle,
        groupCount: section ? _toConsumableArray((0, $3yVy0$getChildNodes)(section, state.collection)).length : 0,
        optionText: focusedItem["aria-label"] || focusedItem.textValue || "",
        isSelected: isSelected
      });
      (0, $3yVy0$announce)(announcement);
    }
    lastSection.current = sectionKey;
    lastItem.current = itemKey;
  });
  // Announce the number of available suggestions when it changes
  var optionCount = (0, $3yVy0$getItemCount)(state.collection);
  var lastSize = (0, $3yVy0$useRef)(optionCount);
  var lastOpen = (0, $3yVy0$useRef)(state.isOpen);
  (0, $3yVy0$useEffect)(function () {
    // Only announce the number of options available when the menu opens if there is no
    // focused item, otherwise screen readers will typically read e.g. "1 of 6".
    // The exception is VoiceOver since this isn't included in the message above.
    var didOpenWithoutFocusedItem = state.isOpen !== lastOpen.current && (state.selectionManager.focusedKey == null || (0, $3yVy0$isAppleDevice)());
    if (state.isOpen && (didOpenWithoutFocusedItem || optionCount !== lastSize.current)) {
      var announcement = stringFormatter.format("countAnnouncement", {
        optionCount: optionCount
      });
      (0, $3yVy0$announce)(announcement);
    }
    lastSize.current = optionCount;
    lastOpen.current = state.isOpen;
  });
  // Announce when a selection occurs for VoiceOver. Other screen readers typically do this automatically.
  var lastSelectedKey = (0, $3yVy0$useRef)(state.selectedKey);
  (0, $3yVy0$useEffect)(function () {
    if ((0, $3yVy0$isAppleDevice)() && state.isFocused && state.selectedItem && state.selectedKey !== lastSelectedKey.current) {
      var optionText = state.selectedItem["aria-label"] || state.selectedItem.textValue || "";
      var announcement = stringFormatter.format("selectedAnnouncement", {
        optionText: optionText
      });
      (0, $3yVy0$announce)(announcement);
    }
    lastSelectedKey.current = state.selectedKey;
  });
  (0, $3yVy0$useEffect)(function () {
    if (state.isOpen) return (0, $3yVy0$ariaHideOutside)([inputRef.current, popoverRef.current]);
  }, [state.isOpen, inputRef, popoverRef]);
  return {
    labelProps: labelProps,
    buttonProps: _objectSpread(_objectSpread(_objectSpread({}, menuTriggerProps), triggerLabelProps), {}, {
      excludeFromTabOrder: true,
      onPress: onPress,
      onPressStart: onPressStart,
      isDisabled: isDisabled || isReadOnly
    }),
    inputProps: (0, $3yVy0$mergeProps)(inputProps, {
      role: "combobox",
      "aria-expanded": menuTriggerProps["aria-expanded"],
      "aria-controls": state.isOpen ? menuProps.id : undefined,
      // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
      "aria-autocomplete": "list",
      "aria-activedescendant": focusedItem ? (0, $3yVy0$getItemId)(state, focusedItem.key) : undefined,
      onTouchEnd: onTouchEnd,
      // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
      autoCorrect: "off",
      // This disable's the macOS Safari spell check auto corrections.
      spellCheck: "false"
    }),
    listBoxProps: (0, $3yVy0$mergeProps)(menuProps, listBoxProps, {
      autoFocus: state.focusStrategy,
      shouldUseVirtualFocus: true,
      shouldSelectOnPressUp: true,
      shouldFocusOnHover: true
    }),
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  };
}
export { $c350ade66beef0af$export$8c18d1b4f7232bbf as useComboBox };